import React from 'react';
import { StreamVideo, StreamTheme } from '@stream-io/video-react-sdk';
import OutgoingCalls from './components/OutgoingCalls.component';
import MyIncomingCalls from './components/IncomingCalls.component';
import CallUI from './components/CallUI.component';
import { useVideoCallStore } from './videocall.zustandstore';

const GSVideo = () => {
    const { client } = useVideoCallStore();

    if (!client) {
        return (
            <div>
                {/* <input type="text" placeholder="Your Unique Name" ref={userName} />&nbsp;&nbsp; */}
                <button role="button">Generate Call Token</button>
            </div>
        );
    }

    return (
        <StreamVideo client={client}>
            <StreamTheme>
                <CallUI />
                <MyIncomingCalls />
                <OutgoingCalls />
            </StreamTheme>
        </StreamVideo>
    );
};

export default GSVideo;